import { connect, ConnectedProps } from 'react-redux'
import CustomError from '../../../../../../../baseComponents/CustomError'
import { LittleModalCreateEditChildrenFirst } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import locations from '../../../../../../../utils/globals/locations'
import { checkIfCanCreateQuote } from '../../../../../../../utils/globals/order/order'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import useCreateAdjustment from '../../../../../../../utils/hooks/adjustmentDeliveryNote/useCreateAdjustment'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import { BillingGroupPayload } from '../../../../../../../utils/reducers/company/billingGroups'
import { WorkingCenterPayload } from '../../../../../../../utils/reducers/company/workingCenters'
import { getSelectedWorkingCenter } from '../../../../../../../utils/reducers/getters'
import { AdjustmentDeliveryNoteModelTypeExtended } from '../types'

interface ModalCreateAdjustmentDeliveryNoteProps extends ModalEditComponentProps {}

const ModalCreateAdjustmentDeliveryNote: React.FC<ModalCreateAdjustmentDeliveryNoteProps> = ({ setOpened, ...rest }) => {
    return <ModalCreateAdjustmentDeliveryNoteConnect setOpened={setOpened} {...rest} />
}

type ModalCreateAdjustmentDeliveryNoteAfterPermissionsProps = ModalEditComponentProps & ReduxModalCreateAdjustmentDeliveryNoteConnector & {}

const ModalCreateAdjustmentDeliveryNoteAfterPermissions: React.FC<ModalCreateAdjustmentDeliveryNoteAfterPermissionsProps> = ({ userPermissions, allRowData, workingCenters, billingGroups,  ...rest }) => {
    const { t } = useTwinTranslation()
    const workingCenter = getSelectedWorkingCenter()
    const { createAdjustment, addressFields, fileInfo } = useCreateAdjustment({ BillingGroupId: workingCenter?.BillingGroupId, baseURL: locations.adjustmentDeliveryNoteSingle })
    const error = checkIfCanCreateQuote(t, workingCenters?.[workingCenter?.id])
    const fields: FormRender<AdjustmentDeliveryNoteModelTypeExtended> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'custom_name',
                    label: t('customName', 'Nombre personalizado'),
                    component: 'InputWithLabelMargin',
                },
                {
                    name: 'WarehouseId',
                    label: t('warehouse', 'Almacén'),
                    component: 'CustomSelect',
                    items: workingCenters?.[workingCenter?.id]?.dictWarehouses || {},
                    value: workingCenters?.[workingCenter?.id]?.warehouseMain || '',
                    required: true
                },
                ...fileInfo,
                {
                    name: 'CurrencyId',
                    component: 'InputHidden',
                    value: workingCenter?.CurrencyId
                },
                {
                    name: 'BillingWorkingCenterId',
                    component: 'InputHidden',
                    value: workingCenter?.id
                },
                {
                    name: 'WorkingCenterId',
                    component: 'InputHidden',
                    value: workingCenter?.id
                },
            ]
        },
        ...addressFields,
        {
            cols:1, 
            elements: [
            ],
        },
    ]
    return (
        <LittleModalCreateEditChildrenFirst fields={error ? [] : fields} url={'/api/app/order/adjustmentDeliveryNote/createAdjustmentDeliveryNote'} imagePath={['tmp']} translations={{
            title: t('newAdjustmentDeliveryNote', 'Nuevo albarán de regulación'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={!error}  {...{ ...rest, onSubmit: createAdjustment }} >
            {error ? <CustomError textError={error} className='mb-10' /> : null}
            {!workingCenters?.[workingCenter?.id]?.dictCounters && !error ? <CustomError className='mb-10'  textError={t('notFoundWorkingCenterCounterAndForceCreate', 'No se han encontrado contadores disponibles. Si decide continuar, se generará uno automáticamente.')} /> : null}
        </LittleModalCreateEditChildrenFirst>)
}

const modalCreateAdjustmentDeliveryNoteDispatch = {
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
    setBillingGroups: (payload: BillingGroupPayload) => ({ type: 'CHANGE_BILLINGGROUP', payload }),
}
const mapModalCreateAdjustmentDeliveryNoteConnector = (state: AllReduxPayloads) => ({ workingCenters: state.workingCenters, billingGroups: state.billingGroups })
const modalCreateAdjustmentDeliveryNoteConnector = connect(mapModalCreateAdjustmentDeliveryNoteConnector, modalCreateAdjustmentDeliveryNoteDispatch)
type ReduxModalCreateAdjustmentDeliveryNoteConnector = ConnectedProps<typeof modalCreateAdjustmentDeliveryNoteConnector>
const modalCreateAdjustmentDeliveryNoteConnectLoading = withLoading(ModalCreateAdjustmentDeliveryNoteAfterPermissions, [{ fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }, { fetchUrl: '/api/app/config/billingGroup/getAllBillingGroupsComplete', propName: 'billingGroups', setFunctionName: 'setBillingGroups'}])
const ModalCreateAdjustmentDeliveryNoteConnect = modalCreateAdjustmentDeliveryNoteConnector(modalCreateAdjustmentDeliveryNoteConnectLoading)


export default ModalCreateAdjustmentDeliveryNote